import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { environment } from '../../../../environments/environment';

export interface ComparisonResult {
  row_number: number;
  status: string;
  data: any;
  errors?: string[];
  warnings?: string[];
}

export interface TestResult {
  success: boolean;
  total_rows: number;
  valid_rows: number;
  invalid_rows: number;
  results: ComparisonResult[];
  cleaned_data?: any[];
}

export interface AIProcessedData {
  success: boolean;
  total_rows: number;
  processed_data: any[];
  errors?: string[];
  ai_summary?: string;
}

@Injectable({
  providedIn: 'root'
})
export class TestService {
  private apiUrl = `${environment.apiUrl}${environment.apiEndpoint}/test`;

  constructor(private http: HttpClient) {}

  async aiProcessFile(formData: FormData): Promise<AIProcessedData> {
    return await firstValueFrom(
      this.http.post<AIProcessedData>(`${this.apiUrl}/ai-process`, formData)
    );
  }

  async cleanAndExport(formData: FormData, format: 'excel' | 'csv' = 'excel'): Promise<Blob> {
    return await firstValueFrom(
      this.http.post(`${this.apiUrl}/clean-export?export_format=${format}`, formData, {
        responseType: 'blob'
      })
    );
  }

  async uploadAndTest(formData: FormData): Promise<TestResult> {
    return await firstValueFrom(
      this.http.post<TestResult>(`${this.apiUrl}/upload`, formData)
    );
  }

  async validateData(data: any[]): Promise<TestResult> {
    return await firstValueFrom(
      this.http.post<TestResult>(`${this.apiUrl}/validate`, { data })
    );
  }

  async cleanData(data: any[]): Promise<any[]> {
    const response = await firstValueFrom(
      this.http.post<{ cleaned_data: any[] }>(`${this.apiUrl}/clean`, { data })
    );
    return response.cleaned_data;
  }
}
